import * as React from 'react';
import { ClearButton } from '../button/ClearButton';
import './PageComponent.scss';

// #region Component Props

interface IProps {
    heading         : any;
    actionText      : string;
    actionIcon      : string;
    actionClick     : any;
    actionDisable   : any;
    id              : string;
}

// #endregion

const PageActionHeading = (props: IProps) => {

    const { 
        id, 
        heading, 
        actionText, 
        actionIcon, 
        actionClick,
        actionDisable 
    } = props;

    return <div className="pageaction-heading">
                <h2>{ heading }</h2>
                {
                    actionClick 
                    ? <ClearButton
                        id={ id }
                        text={ actionText }
                        icon={ actionIcon }
                        disabled={ actionDisable }
                        onBtnClick={ actionClick } 
                    /> 
                    : null
                }                
            </div>;
};

PageActionHeading.defaultProps = {
    actionDisable: () => false,
    actionClick: null,
    actionText: '',
    actionIcon: ''
};

export { PageActionHeading };
